import React from 'react';

function CampaignStatsFilters({
    searchTerm,
    onSearchTermChange,
    searchField,
    onSearchFieldChange,
    searchFields,
    statusFilter,
    onStatusFilterChange,
    statusOptions,
    sortBy,
    onSortByChange,
    sortFields,
    sortOrder,
    onSortOrderChange,
    onSubmit,
    onClear,
    canClear,
}) {
    return (
        <form onSubmit={onSubmit} className="campaign-stats-filters process-queue-filters">
            <div className="row g-1 g-md-2 align-items-center process-queue-filters__row">
                <div className="col-12 col-md-6 col-lg-auto process-queue-filters__item process-queue-filters__item--search">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Search</span>
                        <input
                            type="text"
                            className="form-control process-queue-filters__control"
                            placeholder="Search results…"
                            value={searchTerm}
                            onChange={(e) => onSearchTermChange(e.target.value)}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => onSearchTermChange('')}
                                aria-label="Clear search input"
                            >
                                <i className="bi bi-x"></i>
                            </button>
                        )}
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Search in</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={searchField}
                            onChange={(e) => onSearchFieldChange(e.target.value)}
                        >
                            {searchFields.map((field) => (
                                <option key={field.value} value={field.value}>
                                    {field.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Status</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={statusFilter}
                            onChange={(e) => onStatusFilterChange(e.target.value)}
                        >
                            <option value="">All statuses</option>
                            {statusOptions.map((status) => (
                                <option key={status.value} value={status.value}>
                                    {status.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Sort by</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={sortBy}
                            onChange={(e) => onSortByChange(e.target.value)}
                        >
                            {sortFields.map((field) => (
                                <option key={field.value} value={field.value}>
                                    {field.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Order</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={sortOrder}
                            onChange={(e) => onSortOrderChange(e.target.value)}
                        >
                            <option value="ASC">Ascending</option>
                            <option value="DESC">Descending</option>
                        </select>
                    </div>
                </div>

                <div className="col-12 col-lg-auto process-queue-filters__actions d-flex flex-nowrap gap-2">
                    <button type="submit" className="btn btn-primary btn-sm text-nowrap">
                        <i className="bi bi-search me-1"></i>
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm text-nowrap"
                        onClick={onClear}
                        disabled={!canClear}
                        title="Clear filters"
                    >
                        <i className="bi bi-x-lg me-1"></i>
                        Clear
                    </button>
                </div>
            </div>
        </form>
    );
}

export default CampaignStatsFilters;
